import React from 'react';
import { useTracker } from '../../utils/contexts/tracker-context';
import { useTranslation } from 'react-i18next';
import './DeliveryPopupModalContentStyle.css';

export default function CallRestaurantModalContent(props) {
    const { onClickHandler, restaurant } = props;

    const { t } = useTranslation();
    const { trackDataFn } = useTracker();
    // const { t } = useTranslation();

    async function callHandler() {
        await trackDataFn(restaurant.id, restaurant.token, "phonecall", {}, restaurant.has_orders);
        // try {
        //     await window.fbq('track', 'Contact');
        // } catch (e) {
        //     console.log({ pixelError: e })
        // }
    }

    return (
        <div className="callrestaurant-modal-content overflow-auto text-black ">
            <div className="px-3 pt-6 text-center">
                <p>{t("callrestaurantmodalcontent.p_1")}</p>
            </div>
            <div onClick={() => callHandler()} className="text-center py-2 mx-8 mt-3 rounded-full border border-mycia-red">
                <a href={`tel:${restaurant.phone_number}`} onClick={onClickHandler}>{t("callrestaurantmodalcontent.a_1")}</a>
            </div>
            <div className="text-center ">
                <button className="py-2 underline" onClick={onClickHandler}>{t("callrestaurantmodalcontent.button_1")}</button>
            </div>
        </div>
    );
}
